export interface MovementPriceDTO {
  urgentPrice?: number;
  standardPrice?: number;
}
